import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarCheck, X, ArrowRight, Sparkle } from '@phosphor-icons/react';

const KEY = 'ai_scheduler_promo_dismissed';

export const AISchedulerPromo = ({ role = 'contractor' }) => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(`${KEY}_${role}`) === '1');

  if (dismissed) return null;
  const dismiss = () => {
    localStorage.setItem(`${KEY}_${role}`, '1');
    setDismissed(true);
  };

  if (role === 'worker') {
    return (
      <div className="relative flex items-center gap-3 bg-emerald-50 dark:bg-emerald-900/20 border-2 border-emerald-600 rounded-xl px-4 py-3 mb-4 shadow-[3px_3px_0px_#059669]" data-testid="ai-scheduler-promo-worker">
        <CalendarCheck size={24} weight="fill" className="text-emerald-600 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="font-bold text-sm text-emerald-900 dark:text-emerald-100">
            <span className="bg-emerald-600 text-white text-[9px] font-black uppercase tracking-wider px-1.5 py-0.5 rounded-full mr-1.5">New</span>
            Contractors can now book you straight onto job schedules
          </p>
          <p className="text-xs text-emerald-800/80 dark:text-emerald-200/80 mt-0.5">Keep your availability calendar updated so the AI matches you to more work.</p>
        </div>
        <button onClick={() => navigate('/my-availability')} className="h-9 px-4 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold shrink-0" data-testid="promo-update-availability-btn">
          Update Availability
        </button>
        <button onClick={dismiss} className="w-7 h-7 rounded-full hover:bg-emerald-100 dark:hover:bg-emerald-800 text-emerald-700 dark:text-emerald-300 flex items-center justify-center shrink-0" data-testid="promo-dismiss-worker">
          <X size={14} weight="bold" />
        </button>
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden bg-[#EA580C] border-2 border-[#0F172A] rounded-xl p-5 mb-4 shadow-[4px_4px_0px_#0F172A]" data-testid="ai-scheduler-promo-contractor">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="w-12 h-12 bg-white/20 border-2 border-white/40 rounded-xl flex items-center justify-center shrink-0">
          <CalendarCheck size={26} weight="fill" className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-white text-lg leading-tight flex items-center gap-2 flex-wrap">
            <span className="bg-white text-[#EA580C] text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded-full">New</span>
            AI Scheduling Engine
          </p>
          <p className="text-orange-100 text-sm mt-0.5">
            Describe any job — AI builds the phase-by-phase plan, then matches your best available crew to each phase. Delays cascade automatically.
          </p>
        </div>
        <button
          onClick={() => navigate('/ai-scheduler')}
          className="h-11 px-5 rounded-full bg-white hover:bg-orange-50 text-[#EA580C] font-bold text-sm flex items-center justify-center gap-1.5 shrink-0 active:scale-95 transition-all"
          data-testid="promo-open-scheduler-btn"
        >
          <Sparkle size={16} weight="fill" /> Try It Now <ArrowRight size={15} weight="bold" />
        </button>
      </div>
      <button onClick={dismiss} className="absolute top-2.5 right-2.5 w-7 h-7 rounded-full hover:bg-white/20 text-white/80 flex items-center justify-center" data-testid="promo-dismiss-contractor">
        <X size={14} weight="bold" />
      </button>
    </div>
  );
};
